import { fixedAssets } from 'src/containers/PreCache'
import styled from 'styled-components'

export const PageStyle = styled.div`
  background: #000;

  .header-banner {
    background-image: url(${fixedAssets.top});
    background-position: center top;
    background-size: cover;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 3rem 3rem;
    margin-bottom: 48px;
    position: sticky;
    z-index: 10;
  }
  .agenda-grid {
    display: grid;
    padding-bottom: 5rem;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 30px;
    grid-auto-rows: max-content;
  }
  .right-section {
    display: flex;
    flex-direction: column;
    width: 20%;
    margin-right: 30px;
  }
  .auditorium-btn {
    color: white;
    border: 1px solid #B4173A;
    background-color: #B4173A;
    display: block;
    margin: auto;
    padding: 8px 18px;
    font-weight: 600;
    font-size: 14px;
    text-transform: uppercase;
    transition: all 200ms ease-in;
    &:hover {
      color: #B4173A; 
      background-color: transparent;
    }
  }
`